import { create } from 'zustand'

import { Route } from '@apps-common/types/routes'

interface INavigationHistoryStore {
  history: Route[]
  add: (route: Route) => void
  previous: () => Route | undefined
}

export const useNavigationHistory = create<INavigationHistoryStore>((set, get) => ({
  history: [],
  add: (route: Route) => {
    const { history } = get()

    return set({ history: [...history, route] })
  },
  previous: () => {
    const { history } = get()

    if (history?.length > 1) {
      return history[history.length - 2]
    }

    return undefined
  }
}))
